/**
 * @author Jersson Stiven Morales Alza
 * @Copyright (c) Infotrack. All rights reserved.
 */
import {
    AppBar,
    Button,
    Card,
    CardContent,
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    TextField,
    Toolbar,
    FormControlLabel,
    Checkbox,
} from '@material-ui/core';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import React from 'react';
import { IFormularioTiposClientesVistaProps } from '../interfaces';

const FormularioTiposClientesVista: React.FunctionComponent<IFormularioTiposClientesVistaProps> = ({
    accionCrearEditar,
    cambiarInfoFomulario,
    cerrarFormulario,
    estadoFormulario,
    esMovil,
    tiposClientes,
    tipoFormulario,
}) => (
    <Dialog open={estadoFormulario}>
        <AppBar position="static">
            <Toolbar>
                <Grid container justifyContent="center">
                    <Texto
                        align="center"
                        color="inherit"
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'tiposClientes.agregarTiposClientes'
                                : 'tiposClientes.modificarTiposClientes'
                        }
                    />
                </Grid>
            </Toolbar>
        </AppBar>
        <DialogContent>
            <Card>
                <CardContent>
                    <Grid container spacing={4}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label={<Texto id="tiposClientes.tipoClienteDescripcion" display="inline" />}
                                name="TipoClienteDescripcion"
                                onChange={cambiarInfoFomulario}
                                required
                                value={tiposClientes.TipoClienteDescripcion}
                                id={`TipoClienteDescripcion-${tiposClientes.TipoClienteDescripcion}`}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        color="primary"
                                        checked={Number(tiposClientes.Estado) === 1 ? true : false}
                                        onChange={cambiarInfoFomulario}
                                    />
                                }
                                label={<Texto id="productos.estado" display="inline" />}
                                name="Estado"
                                id={`Estado`}
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </DialogContent>
        <DialogActions>
            <Grid container justifyContent="flex-end" spacing={4}>
                <Grid item>
                    <Button
                        onClick={cerrarFormulario}
                        color="secondary"
                        variant="contained"
                        id="boton-cancelarTiposClientes"
                    >
                        <Texto id="boton.cancelar" />
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        onClick={accionCrearEditar}
                        color="primary"
                        variant="contained"
                        id="boton-guardarTiposClientes"
                    >
                        <Texto id="boton.guardar" />
                    </Button>
                </Grid>
            </Grid>
        </DialogActions>
    </Dialog>
);

export default FormularioTiposClientesVista;
